export default __webpack_public_path__ + "static/media/pic7.dd50593b.PNG";